import { DatePipe } from '@angular/common';
import { Component, OnInit,ViewChild } from '@angular/core';
import { ServiceLayer } from '../../../services/serviceLayer';
import { Settings } from '../../../services/settings';
import { DAO } from './../../../../app/modal/DAO';
import { LandingComponent } from '../.././landing/landing.component';
import * as _ from 'lodash';
declare var $: any;
declare var require: any
@Component({
  selector: 'app-search-policies',
  templateUrl: './policies.component.html',
  // styleUrls: ['./policies.component.css']
})
export class PoliciesComponent implements OnInit {
  constructor(private serviceLayer: ServiceLayer, private setting: Settings, public dao: DAO,
    public datepipe:DatePipe) { }
  public jp = require('jsonpath')
  public policiesList: any = []
  public initialPoliciesList: any = []
  public suggestpolicies = [];
  public policyNumberModal: any;
  public WantToList:any = [];
  public wantedId:any;
  public isClaimFound:boolean = false;
  public isPendingAmendment:boolean = false;
  public statusValue:boolean=false;
  public currentPolicy:any;
  public reasonDropdown:any;
  public viewALL:boolean=false;
  public showCancelPopup:boolean=false;
  public showPolicyConfirm:boolean=false;  
  public isBPMiAmend:boolean=false;    
  public IsCancel: boolean = false;
  public cancelPopupDetails: any = [];
  public policyDetail:any;
  async ngOnInit(){
    this.initialPoliciesList = await this.getPolicies();
    this.getReason();
  }
  //======get policies based on loged in user mail id=============
  async getPolicies() {
    // var result = (window.localStorage.getItem("policyQuotesList") != "undefined" ? JSON.parse(window.localStorage.getItem("policyQuotesList")):null);
    var result = await this.serviceLayer.getSearchPoliciesList('Policy')
    if(result != undefined && result != null) {
      this.policiesList=result.filter(s => s.typeName == 'Policy');
    }
    var WantToList = [
      { "label": "Report a claim", "value": "Report a claim", "disabled": false },
      { "label": "Manage a policy", "value": "Manage my policy", "disabled": false },
      { "label": "Request Evidence of insurance", "value": "Request Evidence of insurance", "disabled": false },
      { "label": "Cancel a policy", "value": "Cancel my policy", "disabled": false }
    ];
    if (this.policiesList != undefined && this.policiesList.length > 0) {
      this.policiesList.forEach(policy => {
        policy['wantedTo'] = _.cloneDeep(WantToList);
        if (['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'].includes(policy.status.toUpperCase())) {
          policy['wantedTo'][2].disabled = true;
          policy['wantedTo'][3].disabled = true;
        }
      });
    }
    if(this.policiesList.length>0) {
      this.policiesList.forEach(element => {
        element.expireDate = this.datepipe.transform(element.expireDate,"MM/dd/yyyy")
        element.effectiveDate =  this.datepipe.transform(element.effectiveDate,"MM/dd/yyyy")
        element.value = null;
      });      
    }
    let userData:any={};
    userData.Email = this.dao?.loginUserDetail?.email;
    userData.AgencyCode = this.dao.agencyCode;
    userData.ProgressToPage = window.localStorage.getItem("policyType");
    let payloadDetail:any={};
    payloadDetail.endPointURL =await this.serviceLayer.getEndPoint("policies", "searchPoliciesGrid", [this.dao.loginUserDetail.email, this.dao.loginUserDetail?.isInternal == false ? this.dao.loginUserDetail?.isInternal : true, (this.dao.loginUserDetail?.agencies == undefined || this.dao.loginUserDetail?.agencies == '') ? null : this.dao.loginUserDetail?.agencies]);
    payloadDetail.payload = "";
    payloadDetail.response = this.policiesList;
    userData.Payload = JSON.stringify(payloadDetail);
    userData.TransactionStatus = "Success";
    userData.RateOnly = false;
    userData.ActionType = "Load Policy List"; 
    await this.serviceLayer.postUserActivity(userData);
    this.policiesList.forEach(element => {
      element.effectiveDate = new Date(element.effectiveDate)
      element.expireDate = new Date(element.expireDate)
    });
    return this.policiesList;
  }

  //====PolicyWantTo===
  async PolicyWantedTo(policyDetails) {
    //==QuoteWantedTo===
    if((['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'].includes(policyDetails.status.toUpperCase()) && (policyDetails.value == 'Cancel my policy' || policyDetails.value == 'Request Evidence of insurance' ))){
      setTimeout(() => {
        if(this.policiesList.length>0) {      
          var currentPolicy = this.policiesList.filter(x=>x.policyNumber == policyDetails.policyNumber);
          currentPolicy[0].value = null;
        }
      }, 1);    
    } 
    else if(policyDetails.value == 'Cancel my policy'){
      this.currentPolicy = policyDetails;
      this.showCancelPopup = true;
      let policyDetail:any = await this.serviceLayer.getPolicyDetails(this.currentPolicy.policyNumber,this.currentPolicy.policyMod);
      this.policyDetail = _.cloneDeep(policyDetails);
      this.isPendingAmendment = false; 
      this.isClaimFound = false;
      if(policyDetail && policyDetail.claimDetails && policyDetail.claimDetails.length > 0 && policyDetail.claimDetails[0].status == 'Open'){
        this.isClaimFound = true;
      }
      if(policyDetail && policyDetail.numberOfPendingAmendments != undefined && policyDetail.numberOfPendingAmendments != '' && Number(policyDetail.numberOfPendingAmendments) > 0){
        this.isPendingAmendment = true; 
      }
      this.dao.agencyCode = policyDetail?.agencyInfo?.code;
      this.dao.policyNumber = this.currentPolicy.policyNumber;
      this.dao.insuredName = this.currentPolicy.insuredName;
      let userData:any={};
      userData.Email = this.dao?.loginUserDetail?.email;
      userData.AgencyCode = policyDetail?.agencyInfo?.code;
      userData.PolicyNumber = this.currentPolicy.policyNumber;
      userData.InsuredName = this.dao.insuredName;
      userData.ProgressToPage = window.localStorage.getItem("policyType");
      let payloadDetail:any={};
      payloadDetail.endPointURL =await this.serviceLayer.getEndPoint("ManagePolicy", "PolicyDetails", [this.dao.loginUserDetail.userCompany,policyDetails.policyNumber,50]);
      payloadDetail.payload = "";
      payloadDetail.response = policyDetail;
      userData.Payload = JSON.stringify(payloadDetail);
      userData.TransactionStatus = "Success";
      userData.RateOnly = false;
      userData.ActionType = "Load Cancel Policy Details"; 
      await this.serviceLayer.postUserActivity(userData);
    }
    else if(policyDetails.value == 'Manage my policy'){
      this.currentPolicy = policyDetails;      
      window.localStorage.setItem("policyType", "Manage a Policy");
      window.localStorage.setItem("currentPolicy",  JSON.stringify(this.currentPolicy));
      let userData:any={};
      userData.Email = this.dao?.loginUserDetail?.email;
      userData.PolicyNumber = this.currentPolicy.policyNumber;
      userData.ProgressToPage = window.localStorage.getItem("policyType");
      userData.TransactionStatus = "Success";
      userData.RateOnly = false;
      userData.ActionType = "Open Policy from View Policies"; 
      await this.serviceLayer.postUserActivity(userData);
      location.href = "/xps/policyQuotes"
    }
    else if(policyDetails.value == 'Request Evidence of insurance'){
      this.currentPolicy = policyDetails;      
      window.localStorage.setItem("policyType", "Request Evidence of insurance");
      window.localStorage.setItem("currentPolicy",  JSON.stringify(this.currentPolicy));
      let userData:any={};
      userData.Email = this.dao?.loginUserDetail?.email;
      userData.PolicyNumber = this.currentPolicy.policyNumber;
      userData.ProgressToPage = window.localStorage.getItem("policyType");
      userData.TransactionStatus = "Success";
      userData.RateOnly = false;
      userData.ActionType = "Open Policy from View Policies"; 
      await this.serviceLayer.postUserActivity(userData);
      location.href = "/xps/evidenceofinsurance"
    }
    else if(policyDetails.value == 'Report a claim'){
      this.currentPolicy = policyDetails;
      window.localStorage.setItem("policyType", "Report a claim");
      window.localStorage.setItem("currentPolicy",  JSON.stringify(this.currentPolicy));
      let userData:any={};
      userData.Email = this.dao?.loginUserDetail?.email;
      userData.PolicyNumber = this.currentPolicy.policyNumber;
      userData.ProgressToPage = window.localStorage.getItem("policyType");
      userData.TransactionStatus = "Success";
      userData.RateOnly = false;
      userData.ActionType = "Open Policy from View Policies"; 
      await this.serviceLayer.postUserActivity(userData);
      location.href = "/xps/reportclaim"
    }
  }

  async getReason() {
    await this.serviceLayer.getCancelReasonDetails();
    let response = JSON.parse(window.localStorage.getItem("policyReasons"));
    if (response != undefined && response.originalObj.questionnaire != undefined) {
      var cancelQuestionnaire = this.jp.query(response.originalObj.questionnaire,"$..[?(@.key =='CancelQuestionnare')]")[0];
      this.reasonDropdown = this.jp.query(cancelQuestionnaire.questionAnswer,"$..[?(@.key == 'cancelReasonCd')]")[0].questionOptions;
      this.cancelPopupDetails = response['originalObj'];
    }
  }

  async pushCancelDetails(policy) {
    this.currentPolicy.isClaimFound = this.isClaimFound;
    this.currentPolicy.isPendingAmendment = this.isPendingAmendment;
    this.currentPolicy.referenceNumber = this.currentPolicy.referenceNumber === '' ? null : this.currentPolicy.referenceNumber; 
    let response = await this.serviceLayer.cancelationDetail(this.cancelPopupDetails,this.currentPolicy,false,policy?.totalPremiumAmount);
    if (response != undefined && !response) {
      this.dao.policyNumber = this.currentPolicy.policyNumber;
      $("#cancelModal").modal('hide');
      this.showPolicyConfirm = true;
      this.isBPMiAmend = this.dao.closedPopupModel.isBPmiAmendment == true;
      this.IsCancel = true;
      var result = this.getPolicies()
      this.dao.closedPopupModel.isShowError = false;
      this.dao.closedPopupModel.cancelReasonCdModal = null;
      this.dao.closedPopupModel.cancelOCP = false;
      this.popUpClose(this.dao);
    }
    return response;
  }

  popUpClose(event) {
    this.showCancelPopup = false;
    this.IsCancel = false;
    if(this.policiesList.length>0){
      var currentPolicy = this.policiesList.filter(x=>x.policyNumber == event.policyNumber);
    }
    currentPolicy[0].value = null; 
    $("#cancelModal").modal('hide');   
  } 

  //=======serach button click========
  async searchPolicyDetails(){
  }
  //=============get color code based on status============
  getColorCode(status) {
    return this.serviceLayer.getColorCode(status)
  }
  //=============redirect the page when click the edit===============
  isEditPolicyDetails(referenceNumber, productCode, companyCode) {
    let urlDetails = [companyCode, productCode, referenceNumber,];
    let getUrl = this.setting.getServicePayloadDetails('policies', 'openQuickQuoteLink', urlDetails);
    window.open(getUrl.endPointInfo.endPointUrl, '_blank');
  }

  //==============load policy number into auto complete box===========
  async getPolicyBasedOnNumber(event) {
    this.suggestpolicies = [];
    this.suggestpolicies = await this.serviceLayer.getThePolicyNumber(this.initialPoliciesList, event);
  }
  //============get policy based on status=========
  async getPolicyBasedOnFilter() {
    let searchFileter = { SearchValue: this.policyNumberModal }
    this.policiesList = await this.serviceLayer.getSearchPoliciesList('Policy', searchFileter);
    if(this.policiesList != undefined && this.policiesList != null && this.policiesList.length >0) {
      this.policiesList.forEach(element => {
        element.expireDate = this.datepipe.transform(element.expireDate,"MM/dd/yyyy")
        element.effectiveDate =  this.datepipe.transform(element.effectiveDate,"MM/dd/yyyy")
       });
    }
    return this.policiesList;
  }
  //=============export excel================
  async exportExcel(data: any) {
    if(this.policiesList.length>0) {
      let exportColumns=[
        {lable:"Policy Number",fields:'policyNumber'},
        {lable:"Name Insured",fields:'nameInsured'},
        {lable:"Effective Date",fields:'effectiveDate'},
        {lable:"Expire Date",fields:'expireDate'},
        // {lable:"Effective Date",fields:'effectiveDate',rule:"this.datepipe.transform(new Date({0}), 'MM/dd/yyyy') "},
        // {lable:"Expire Date",fields:'expireDate',rule:"this.datepipe.transform(new Date({0}), 'MM/dd/yyyy') "},
        {lable:"Line of Business",fields:'lineOfBusinuss'},
        {lable:"Jobsite Address",fields:'jobSiteAddress'},
        {lable:"Status",fields:'status'}
      ];
      await this.serviceLayer.exportExcel(data.value,exportColumns,'policiesDetail');
    }
  }

  //======View all data=============
  ViewAll() {
    if(this.viewALL) {
      this.viewALL = false;
    }
    else {
      this.viewALL = true;
    }
  }

}
